module.exports = __webpack_public_path__ + "img/eighteen-msg.d6c9758b.png";